function normalizeRoute(route) {
    const result = route.replace(/ /g, '');
    if (result.startsWith('/')) {
        return result.substring(1);
    }
    return result;
}
export default normalizeRoute;
//# sourceMappingURL=normalizeRoute.js.map